"use strict";
/*
 * Created on 12. 2. 2019
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var ProductName_1 = require("../../product/model/ProductName");

var PriceChangeReportPricesDTO_1 = require("./PriceChangeReportPricesDTO");
/**
 * Price Change Report DTO
 *
 * @author SKu
 */


var PriceChangeReportDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(PriceChangeReportDTO, _DomainObject_1$Domai);

  /**
   * DTO used for PriceChange report
   * @param releaseName release name
   * @param productInfo instance of ProductName
   * @param prices releaseItem prices DTO(that has inside FP and comments)
   * @param approvedBy User name, who approved category(PM manager)
   * @param approveDate
   */
  function PriceChangeReportDTO(releaseName, productInfo, prices, approvedBy, approveDate) {
    var _this;

    _classCallCheck(this, PriceChangeReportDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceChangeReportDTO).call(this));
    _this.releaseName = releaseName;
    _this.productInfo = productInfo;
    _this.prices = prices;
    _this.approvedBy = approvedBy;
    _this.approveDate = approveDate;
    return _this;
  }

  return PriceChangeReportDTO;
}(DomainObject_1.DomainObject);

exports.PriceChangeReportDTO = PriceChangeReportDTO;

PriceChangeReportDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PriceChangeReportDTO.name);
  return {
    releaseName: builder.str('releaseName'),
    productInfo: builder.obj('price', ProductName_1.ProductName.schema, function (mat) {
      return new ProductName_1.ProductName(mat.id, mat.externalId, mat.name);
    }),
    prices: builder.listOf(builder.obj('price', PriceChangeReportPricesDTO_1.PriceChangeReportPricesDTO.schema, function (mat) {
      return PriceChangeReportPricesDTO_1.PriceChangeReportPricesDTO.fromDataDict(mat);
    })),
    approvedBy: builder.opt(builder.str('approvedBy')),
    approveDate: builder.opt(builder.date('approveDate', DateParser_1.DateParser.ISO_PATTERN))
  };
}();